import axios, { AxiosResponse } from 'axios';
import { apiConfig } from 'config';
import { PATH_AUTH } from 'routes/paths';
import { history } from 'routes/history';
import { getAuthTokenCookie, getRefreshTokenCookie } from 'utils/jwt';

export interface ApiParameters {
  url: string | undefined;
  method: any;
  headers?: { [key: string]: string };
  params?: { [key: string]: any };
  baseURL?: string;
  body?: any;
  timeout?: number;
  responseType?: any;
  withCredentials?: boolean;
  responseEncoding?: string;
}

const onSuccess = (response: any) => {
  return Promise.resolve(response);
};

const noReloadErrors: string[] = [
  'Account locked due to 3 incorrect login attempts, contact administrator',
  'Unauthorized, please check your credentials',
  'Account inactive, contact administrator',
  'The link has expired'
];

const onError = (error: any) => {
  const { message, response } = error;
  console.error(`Server Side Error: ${message ? message : response ? response.data : 'Unknown'}`);
  if (response) {
    const { status, data } = response || {};
    const message = data?.messages[0] ? data?.messages[0] : data;
    if (status === 401) {
      localStorage.removeItem('UserInfo');
      if (!noReloadErrors.includes(message)) {
        history.push(PATH_AUTH.root);
        location.reload();
      }
    }
  }
  return Promise.reject(error.response || error.message);
};

export class WrapperService {
  private requestTimeout = 0; //no timeout;

  public httpCall(apiParam: ApiParameters): Promise<AxiosResponse<any, any>> {
    const {
      baseURL,
      url,
      method,
      params,
      body: data,
      headers,
      timeout,
      responseType,
      withCredentials = getAuthTokenCookie() && getRefreshTokenCookie() ? false : true
    } = apiParam;

    const axiosConfig = {
      url,
      withCredentials,
      method,
      ...(params && { params }),
      ...(data && { data }),
      ...(baseURL
        ? { baseURL }
        : {
            baseURL: apiConfig.asset_mgt
          }),
      ...(headers
        ? { headers }
        : {
            headers: {
              'Content-Type': 'application/json'
            }
          }),
      ...(timeout
        ? { timeout }
        : {
            timeout: this.requestTimeout
          }),
      ...(responseType
        ? { responseType }
        : {
            responseType: 'json'
          })
    };

    return axios
      .request(axiosConfig)
      .then((response) => onSuccess(response))
      .catch((error) => onError(error));
  }
}
